import apiHandler from "../core/apiHandler";

const pdfDesignApi = apiHandler("pdf-designs");

export default pdfDesignApi;
